module.exports = __webpack_public_path__ + "static/media/15-6.5c730e48.mp3";